<!--
    描述：新增编码规则选择适用单位弹框
    时间：2020-07-30
    Created by yefan
-->
<template>
	<div class="h100">
		<div class="w-table-layout">
			<div class="w-table-content"
				 ref="deptsContent">
				<el-table :data="deptsTreeData.tableData"
						  row-key="id"
						  v-loading="deptsTreeData.loading"
						  ref="deptsTree"
						  :expand-row-keys="deptsTreeData.expandKeys"
						  :height="deptsTreeData.tableH"
						  border
						  highlight-current-row
						  :tree-props="{children: 'children'}">
					<el-table-column type="selection"
									 width="55"></el-table-column>
					<el-table-column prop="sname"
									 label="单位名称"
									 show-overflow-tooltip
									 min-width="150"></el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getSysDept } from 'api/system/sys.js'

export default {
	data() {
		return {
			deptsTreeData: {
				loading: false,
				tableH: 500,
				tableData: [],
				expandKeys: []
			}
		}
	},
	methods: {
		// 初始获取数据
		getSysDept() {
			let param = {}
			getSysDept(param).then(res => {
				this.deptsTreeData.tableData = res.data
				if (res.data.length > 0) {
					this.deptsTreeData.expandKeys.push(
						res.data[0].id.toString()
					)
				}
			})
		},

		// 确定按钮事件
		doSave() {
			this.$emit('on-success', this.$refs.deptsTree.selection)
		}
	},
	created() {
		this.getSysDept()
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.deptsTreeData.tableH = this.$refs.deptsContent.offsetHeight
			}, 100)
		})
	},
	computed: {
		...mapState('app', { clientSize: state => state.clientSize })
	},
	watch: {
		clientSize(val) {
			this.deptsTreeData.tableH = this.$refs.deptsContent.offsetHeight
		}
	}
}
</script>
